import { Logo } from "../../../components/Logo"
import classes from "./styles.module.css"

/**
 * Login hero — the brand lockup atop the default (full-bleed art) Lexicanon
 * login, rendered at ~2× the standard size. Pure presentation. The tagline
 * lives separately in `LoginTagline` (beneath the card).
 */
export function LoginHero(): React.JSX.Element {
  return (
    <div className={classes.hero}>
      {/* `zoom` scales the icon SVG + the fixed-size wordmark + their gap
          uniformly AND reflows (unlike transform: scale). The non-zoomed
          parent owns the centring + spacing so they aren't doubled too. */}
      <div className={classes.brand}>
        <Logo size={46} />
      </div>
    </div>
  )
}
